import { render, staticRenderFns } from "./Quotation.vue?vue&type=template&id=d2d88f42&scoped=true"
import script from "./Quotation.vue?vue&type=script&lang=js"
export * from "./Quotation.vue?vue&type=script&lang=js"
import style0 from "./Quotation.vue?vue&type=style&index=0&id=d2d88f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d88f42",
  null
  
)

export default component.exports